<form DraggableDialog [formGroup]="form" (ngSubmit)="submit()">
  <div style="background:#0F1A41;color:white;text-align:center;vertical-align:middle;height:45px">
    <h2 mat-dialog-title style="padding-top:5px">Ändra användare</h2>
  </div>
  <mat-dialog-content>

    <div class="input-row-group" style="margin-top:12px;">
      <mat-form-field floatLabel="always" style="flex:1">
        <mat-label class="mat-input-header">LoginId</mat-label>
        <input type="text" matInput placeholder="LoginId" formControlName="loginId">
      </mat-form-field>

      <mat-checkbox data-cy-checkBox="active" formControlName="active">Aktiv</mat-checkbox>

    </div>

    <div class="input-row-group">

      <mat-form-field floatLabel="always" style="flex:1;padding-right:6px">
        <mat-label class="mat-input-header">Namn</mat-label>
        <input type="text" matInput placeholder="Name" formControlName="name" data-cy-input="name">
      </mat-form-field>

      <mat-form-field floatLabel="always" style="flex:1">
        <mat-label class="mat-input-header">Anställningsnummer</mat-label>
        <input type="text" matInput placeholder="Anställningsnummer" formControlName="employmentNumber">
      </mat-form-field>

    </div>
    <div class="input-row-group">
      <mat-form-field floatLabel="always" style="flex:1;padding-right:6px">
        <mat-label class="mat-input-header">Flygplatser</mat-label>
        <mat-select [formControl]="airports" multiple>
          <mat-select-trigger  data-cy-dropDown="airPorts">
            {{airports.value ? airports.value[0] : ''}}
            <span *ngIf="airports.value?.length > 1" class="additional-selection">
              (+{{airports.value.length - 1}} others)
            </span>
          </mat-select-trigger>
          <mat-option data-cy="options"*ngFor="let airport of airportsValues" [value]="airport">{{airport}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field floatLabel="always" style="flex:1">
        <mat-label class="mat-input-header">Aktuell flygplats</mat-label>
        <mat-select data-cy-dropDown="currentAirport" formControlName="currentAirportID">
          <mat-option data-cy="optionAirports" value="ARN">ARN</mat-option>
        </mat-select>
        <mat-error *ngIf="form.controls.currentAirportID.hasError('required')">Flygplats måste väljas</mat-error>
      </mat-form-field>
    </div>
    <div class="input-group">
      <mat-form-field floatLabel="always">
        <mat-label class="mat-input-header">Kompetenser</mat-label>
        <mat-select [formControl]="skills" multiple data-cy-dropDown="skills">
          <mat-select-trigger>
            {{skills.value ? skills.value[0] : ''}}
            <span *ngIf="skills.value?.length > 1" class="additional-selection">
              (+{{skills.value.length - 1}} others)
            </span>
          </mat-select-trigger>
          <mat-option data-cy="optionSkills" *ngFor="let skill of skillsValues" [value]="skill">{{skill}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field floatLabel="always" *ngIf="isAdmin">
        <mat-label class="mat-input-header">Rättigheter</mat-label>
        <mat-select [formControl]="permissions" data-cy-dropDown="permissions">
          <mat-select-trigger>
            {{permissions.value ? permissions.value : ''}}
          </mat-select-trigger>
          <mat-option data-cy="accesLevel" *ngFor="let permission of permissionValues" [value]="permission">{{permission}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-checkbox data-cy-checkBox="resetPassword" formControlName="changePassword">Nollställ lösenord för användare</mat-checkbox>

    </div>

  </mat-dialog-content>
  <div style="display: flex;flex-direction:row-reverse;margin-right:15px;margin-bottom:15px">
    <button mat-flat-button type="submit" data-cy-btn="save"
            style="margin-left:10px;background:#7AB800" [disabled]="!canSave()">
      Spara
    </button>
    <button mat-button type="button" mat-dialog-close data-cy-btn="close"
            style="margin-left:10px;background:transparent;border-color:grey;color:grey;border-style:solid;border-width:1px">
      Avbryt
    </button>
  </div>

</form>
